import apiClient from '../utils/apiClient';

export default apiClient;
export * from '../utils/apiClient';
